
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__uchebaru_square",
  "use": "icon__uchebaru_square-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"icon__uchebaru_square\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#FFE554\" d=\"M0 0h32v32H0z\" /><path fill=\"#FFC9F1\" d=\"M32 32h32v32H32z\" /><path fill=\"#1D8AFE\" d=\"M8 8h48v48H8z\" /><path d=\"M35.826 25.147c-.87-2.99 3.69-4.351 4.912-1.824.634 1.311-.007 2.845-.599 4.107l-.849 1.784c-2.033 4.204-5.267 10.28-9.104 12.2-2.361 1.18-5.565.6-6.786-1.952-.485-1.012-.573-2.203-.018-3.297.867-1.706 3.098-2.496 4.591-.954.716.739.706 2.45-.526 3.165 2.285.813 4.543-2.732 4.935-3.55-3.465.02-4.193-6.154-5.015-9.37-.34-1.327-1.232-1.347-2.397-.715l-.147.082-.27-1.354.35-.187c1.218-.623 5.239-2.431 6.054.392l.202.794c.855 3.259 2.213 7.377 2.714 7.658 1.087-1.51 2.86-5.321 3.16-6.19.06-1.213-1.207-.79-1.207-.79Z\" fill=\"#FFF\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconUchebaruSquareIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__uchebaru_square" {...restProps} />
    })
  